module.exports = __webpack_public_path__ + "static/media/contact-us.3fb71668.jpg";